import { TableCellProps } from "@mui/material";
import * as React from "react";
import { useActionColumnVisible } from "./columnVisibility";
import { StyledTableCell } from "./CustomTable";

/**
 * The trailing action cell. Drop-in for `<StyledTableCell align="left">` in a
 * table row: it renders nothing at all when its table decided the action column
 * isn't worth a column.
 *
 * That decision is made once, in `useVisibleHeaders`, and reaches both ends —
 * the header through the filtered array, this cell through context — so the two
 * cannot drift apart. They must not: the whole table's widths, truncation and
 * pinned column are selected by column position, and one extra `<td>` puts every
 * one of those rules on the wrong column.
 *
 * Wraps nothing. Rows keep their own `<Box display="flex">` /
 * `StyledActionButtonWrapper`, and anything else they park in the cell — the
 * line-item duplicate modal, for one — comes along unchanged.
 */
export default function ActionCell({ children, ...props }: TableCellProps) {
  const visible = useActionColumnVisible();
  if (!visible) return null;
  return (
    <StyledTableCell align="left" {...props}>
      {children}
    </StyledTableCell>
  );
}
